<script>
// https://tailwind.primevue.org/inlinemessage/
// https://www.figma.com/file/aVvlXy2ApVylKLcw6AAXoo/Goalbook-Design-System%3A-Icons-%26-Components?node-id=8234-982
const gbThemes = ['primary', 'green', 'red', 'grayDark', 'grayLight']
export default {}
</script>
<script setup>
import InlineMessage from 'primevue/inlinemessage'
defineOptions({
  inheritAttrs: false
})

defineProps({
  gbTheme: {
    type: String,
    required: false,
    validator(value) {
      return gbThemes.indexOf(value) > -1
    }
  },
  inline: {
    type: Boolean,
    default: true
  }
})
</script>
<template>
  <InlineMessage v-bind="$attrs" :gb-theme="gbTheme" :severity="null">
    <template #default><slot name="default"></slot></template>
    <template #icon><slot name="icon"></slot></template>
  </InlineMessage>
</template>
